namespace $.$$ {

	export class $shm_ba_post_card extends $.$shm_ba_post_card {

		value( name: string ) {
			const table = this.table() as $shm_ba_data_table | null
			const post_row = this.post_row() as readonly $shm_ba_data_cell[] | null
			if( !table || !post_row ) return ''
			return post_row[ table.head.indexOf( name ) ] ?? ''
		}

		title() {
			return String( this.value( 'Заголовок' ) || this.value( 'Текст' ) || 'Без заголовка' )
		}

		date_time() {
			return String( this.value( 'Дата' ) || '' ).replace( /^\d{4}-\d{2}-\d{2}/, date => this.$.$shm_date.text( date ) )
		}

		url() {
			return String( this.value( 'Url' ) || '' )
		}

		author_url() {
			return String( this.value( 'Url автора' ) || '' )
		}

		author_title() {
			return String( this.value( 'Автор' ) || this.author_url() || '-' )
		}

		source_title() {
			return String( this.value( 'Источник' ) || this.url() || '-' )
		}

		source_url() {
			const url = this.url()
			try {
				return new URL( url ).origin
			} catch( error ) {
				const source = String( this.value( 'Источник' ) || '' ).trim()
				return source ? `https://${ source }` : ''
			}
		}

		title_content() {
			return [ this.Title_text() ]
		}

		meta_content() {
			const parts = [
				[
					this.url() ? this.Date_link() : this.date_time(),
					... this.url() ? [ this.Date_copy() ] : [],
				],
				[ this.source_title() ],
				[
					'Автор: ',
					this.author_url() ? this.Author_link() : this.author_title(),
					... this.author_url() ? [ this.Author_copy() ] : [],
				],
				... this.media_post() ? [] : [ [
					'Аудитория: ',
					this.format_number( this.value( 'Аудитория' ) ) || '-',
				] ],
				[ this.value( 'Тип источника' ) ],
				[ this.value( 'Тип сообщения' ) ],
			].filter( part => part.some( Boolean ) )
			return parts.flatMap( ( part, index )=> [ ... index ? [ ' · ' ] : [], ... part ] )
		}

		text_content() {
			return this.text() ? [ this.Text_text() ] : []
		}

		text() {
			return String( this.value( 'Текст' ) || '' )
		}

		text_collapsible() {
			return this.text().length > 600 || this.text().split( '\n' ).length > 8
		}

		@ $mol_mem
		text_expanded( next?: boolean ) {
			return next ?? false
		}

		text_more_visible() {
			return this.text_collapsible() && !this.text_expanded()
		}

		text_max_height() {
			return this.text_expanded() ? 'none' : '220px'
		}

		text_more( next?: Event ) {
			if( next === undefined ) return null
			this.text_expanded( true )
			return next
		}

		tags() {
			return String( this.value( 'Теги' ) || '' )
		}

		tag_list() {
			return this.tags()
				.split( /\s*,\s*/ )
				.map( tag => tag.trim() )
				.filter( Boolean )
		}

		tag_label( tag: string ) {
			return tag
		}

		tags_content() {
			const tags = this.tag_list()
			return tags.length ? [ 'Теги: ', ... tags.map( tag => this.Tag( tag ) ) ] : []
		}

		metric_names() {
			if( this.media_post() ) return [
				'Аудитория СМИ',
				'Цитируемость СМИ',
			]
			return [
				'Тональность',
				'Просмотров',
				'Комментариев',
				'Репостов',
				'Лайков',
				'Вовлеченность',
			]
		}

		media_post() {
			return String( this.value( 'Тип источника' ) ).toLowerCase().includes( 'сми' )
				|| this.metric_present( 'Аудитория СМИ' )
				|| this.metric_present( 'Цитируемость СМИ' )
		}

		metric_present( name: string ) {
			const value = this.value( name )
			if( value === null || value === undefined || value === '' ) return false
			const number = Number( value )
			if( Number.isFinite( number ) ) return number !== 0
			return String( value ).trim() !== ''
		}

		metrics() {
			return this.metric_names()
				.filter( name => {
					const value = this.value( name )
					return value !== '' && value !== null && value !== undefined
				} )
				.map( name => this.Metric( name ) )
		}

		metric_title( name: string ) {
			return `${ name }: ${ this.format_number( this.value( name ) ) }`
		}

		format_number( value: $shm_ba_data_cell ) {
			const text = String( value ?? '' )
			if( !/^-?\d{5,}$/.test( text ) ) return text
			return text.replace( /\B(?=(\d{3})+(?!\d))/g, ' ' )
		}

	}

}
